// Landing free-promise visibility. A build-time flag, on purpose: the marketing landing is an
// SSR-rendered, `cache:private` page shown to anonymous visitors, where a per-request runtime flag
// is not SSR-correct — a gemi `useFeature` read resolves to its default during the server render and
// only flips on the client, so the promise would ship in the HTML and then flash away (a hydration
// split). `import.meta.env.VITE_FOLIO_AI_SHOW_FREE_PROMISE` is inlined by Vite at build into the
// client AND SSR-render bundles, so the same literal paints on both. Default shows the promise; set
// VITE_FOLIO_AI_SHOW_FREE_PROMISE=off (see the build/deploy note) to hide it.
//
// NOTE the dual read point: gemi builds the client + SSR-render bundles with Vite (this value is
// inlined at build) but the server-route bundle — where the /pricing meta loader lives — with
// Bun.build, which leaves `import.meta.env` as a RUNTIME read. So the flag must be set in BOTH the
// image build env (for the inline) and the runtime env (for the loader). Both default to "on".
export function folioAiShowFreePromise(): boolean {
  // Read import.meta.env first (Vite inlines the literal in the client/SSR bundles), then fall back to
  // process.env for the Bun server-route bundle. The fallback also makes the runtime half survive a
  // future gemi server build that defines this key instead of leaving it a runtime read.
  const raw =
    import.meta.env.VITE_FOLIO_AI_SHOW_FREE_PROMISE ??
    (typeof process !== "undefined"
      ? process.env.VITE_FOLIO_AI_SHOW_FREE_PROMISE
      : undefined);
  // Hide on every false-form the terraform variable validates (off/false/0); unset defaults to show.
  // "0" MUST hide, or the zero-grant rollout (paywall on) still serves the free-credit promise.
  return raw !== "off" && raw !== "false" && raw !== "0";
}
